var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgActivityEarningsIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57343 1.38996C10.0225 0.00806284 11.9775 0.00806355 12.4266 1.38996L13.8067 5.637C14.0075 6.25498 14.5834 6.67339 15.2332 6.67342L19.6989 6.67359C21.1519 6.67364 21.756 8.53297 20.5805 9.38708L16.9678 12.0121C16.4422 12.394 16.2222 13.071 16.423 13.689L17.8028 17.9362C18.2517 19.3181 16.6701 20.4672 15.4945 19.6132L11.8816 16.9885C11.3559 16.6066 10.6441 16.6066 10.1184 16.9885L6.50547 19.6132C5.32992 20.4672 3.74828 19.3181 4.19724 17.9362L5.57705 13.689C5.77782 13.071 5.55785 12.394 5.03217 12.0121L1.41947 9.38708C0.24398 8.53297 0.848111 6.67364 2.30114 6.67359L6.7668 6.67342C7.4166 6.67339 7.99249 6.25498 8.19331 5.637L9.57343 1.38996Z",
    fill: "#FFBE00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActivityEarningsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Activity_Earnings_Icon.8376fd32.svg";
export { ForwardRef as ReactComponent };